import { Tooltip, withStyles } from "@material-ui/core";
export default withStyles(() => ({ tooltip: { fontSize: 13 } }))(Tooltip);
